module.exports = __webpack_public_path__ + "static/media/competency management system.8bd968df.svg";